module.exports = __webpack_public_path__ + "static/img/background.876ce596.svg";